import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function triggerRunscript(assignmentId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments/${assignmentId}/runscript`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function getRunscriptOutput(assignmentId, userId, timestamp) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments/${assignmentId}/users/${userId}/runscript/${timestamp}`;

    const baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "GET";
    baseRequestConfig.headers['content-type'] = 'application/octet-stream';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.blob();
}

export async function getLatestRunscripts(assignmentId, userId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments/${assignmentId}/users/${userId}/runscripts`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}


/** WEBPACK FOOTER **
 ** ./src/connectivity/api.runscript.js
 **/